import React from 'react'
import 'react-toastify/dist/ReactToastify.css'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import ProfileRoutes from '../profile/routes'
import UsersRoutes from '../users/routes'
import ProgressRoutes from '../progress/routes'
import LearningResourcesRoutes from '../learning-resources/routes'
import MessagingRoutes from '../messaging/routes'
import UserReflectionsRoutes from '../user-reflections/routes'
import TestRoutes from '../test/routes'
import ScheduleRoutes from '../schedule/routes'
import CatalogRoutes from '../catalog/routes'
import ExperiencesRoutes from '../experiences/routes'
import ReportsRoutes from '../reports/routes'
import ReflectionPromptsRoutes from '../reflection-prompts/routes'
import DefaultRoutes from './default-routes'
import SystemRoutes from '../system/routes'
import DiscussionRoutes from '../discussions/routes'
import MobileRoutes from '../mobile/routes'
import MobileFooterPrompt from '../mobile/footer-prompt'
import Inquiries from '../inquiries'
import { AutoEnrollmentRoute } from '../../features/auto-enrollment';

const SecuredRoutes = () => {
    return (
        <Inquiries>
            <DefaultRoutes />
            <AutoEnrollmentRoute />
            <ProfileRoutes />
            <UsersRoutes />
            <ProgressRoutes />
            <LearningResourcesRoutes />
            <MessagingRoutes />
            <UserReflectionsRoutes />
            <TestRoutes />
            <ScheduleRoutes />
            <CatalogRoutes />
            <ExperiencesRoutes />
            <ReportsRoutes />
            <SystemRoutes />
            <ReflectionPromptsRoutes />
            <DiscussionRoutes />
            <MobileRoutes />
            <MobileFooterPrompt />
        </Inquiries>
    )
}

export default SecuredRoutes